import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Editors from "@/pages/Editors";
import EditorDetail from "@/pages/EditorDetail";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import { CookieConsent } from "@/components/CookieConsent";

function Layout() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <div className="App flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/editors" element={<Editors />} />
                    <Route path="/editors/:id" element={<EditorDetail />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/cookie" element={<Cookie />} />
                </Routes>
            </main>
            <Footer />
            <CookieConsent />
        </div>
    );
}

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <AuthProvider>
                    <Layout />
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
